<div class="main-container" *ngIf="contactRequestService.contactRequest">
    <div class="table-container">
        <p-button (onClick)="restoreRequest()" label="Restore" [style]="{'width':'120px'}"
            *ngIf="contactRequestService.contactRequest.isDeleted"></p-button>
        <div class="action-title-container">
            <h4>
                Lead information
            </h4>
        </div>
        <table class="contact-table" [formGroup]="contactRequestForm" *ngIf="contactRequestForm">
            <tr class="contact-list-item">
                <td colspan="2">
                    <div class="title-container">
                        <div class="global-tag">
                            {{contactRequestService.contactRequest.source.description}}
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="contact-list-item">
                <td>
                    <p>
                        First name
                    </p>
                </td>
                <td>
                    <input pInputText formControlName="firstName" [style]="{'max-width': '250px'}">
                </td>
            </tr>
            <tr class="contact-list-item">
                <td>
                    <p>
                        Family name
                    </p>
                </td>
                <td>
                    <input pInputText formControlName="lastName" [style]="{'max-width': '250px'}">
                </td>
            </tr>
            <tr class="contact-list-item">
                <td>
                    <p>
                        Date of birth
                    </p>
                </td>
                <td>
                    <p-calendar (onSelect)="updateAgeAtStartDate($event)" formControlName="birthDate"
                        dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                </td>
            </tr>
            <tr class="contact-list-item">
                <td>
                    <p>
                        Age at departure
                    </p>
                </td>
                <td>
                    <span *ngIf="contactRequestService.contactRequest.ageAtStartDate">
                        {{contactRequestService.contactRequest.ageAtStartDate}}
                    </span>
                </td>
            </tr>
            <tr class="contact-list-item">
                <td>
                    <p>
                        Language
                    </p>
                </td>
                <td>
                    <p-dropdown [options]="contactRequestService.languages" optionLabel="name"
                        formControlName="language" (onChange)="languageChange($event.value)"></p-dropdown>
                </td>
            </tr>
            <tr class="contact-list-item">
                <td>
                    <p>
                        City - Country
                    </p>
                </td>
                <td>
                    <input pInputText formControlName="cityCountry">
                </td>
            </tr>
            <tr class="contact-list-item">
                <td>
                    <p>
                        Phone number
                    </p>
                </td>
                <td>
                    <input pInputText formControlName="phoneNumber">
                </td>
            </tr>
            <tr class="contact-list-item">
                <td>
                    <p>
                        Email
                    </p>
                </td>
                <td>
                    <input pInputText formControlName="email">
                </td>
            </tr>
            <tr class="contact-list-item">
                <td>
                    <p>
                        Email 2
                    </p>
                </td>
                <td>
                    <input pInputText formControlName="secondEmail">
                </td>
            </tr>
            <tr class="contact-list-item">
                <td>
                    <p>
                        City
                    </p>
                </td>
                <td>
                    <input pInputText formControlName="city">
                </td>
            </tr>
            <tr class="contact-list-item">
                <td>
                    <p>
                        Postcode
                    </p>
                </td>
                <td>
                    <input pInputText formControlName="postCode">
                </td>
            </tr>
            <tr class="contact-list-item">
                <td>
                    <p>
                        Country
                    </p>
                </td>
                <td>
                    <p-dropdown placeholder="SELECT" dataKey="id" [options]="contactRequestService.countries" formControlName="country"
                        optionLabel="name" [filter]="true" filterBy="name"></p-dropdown>
                </td>
            </tr>
            <tr class="contact-list-item">
                <td>
                    <p>
                        Contact Method
                    </p>
                </td>
                <td>
                    <p-dropdown placeholder="SELECT" dataKey="id" [options]="appointmentTypes"
                        formControlName="appointmentType" optionLabel="name"></p-dropdown>
                </td>
            </tr>
        </table>
    </div>
    <div class="discussion-container">
        <div *ngIf="contactRequestForm">
            <table class="contact-table" [formGroup]="contactRequestForm">
                <tr class="contact-list-item">
                    <td colspan="2">
                        <h4>
                            Programme information
                        </h4>
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td>
                        <p>
                            Programme
                        </p>
                    </td>
                    <td>
                        <textarea [autoResize]="true" pInputTextarea formControlName="interestedIn"
                            [style]="{'width': '100%'}"></textarea>
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td>
                        <p>
                            School
                        </p>
                    </td>
                    <td>
                        <p-dropdown placeholder="SELECT" dataKey="id" [options]="contactRequestService.filteredSchools"
                            formControlName="school" [showClear]="true" optionLabel="name" [filter]="true" filterBy="name" 
                            (onChange)="updateDestination($event.value);updateLviUrl($event.value)" (onClear)="onSchoolClear()"></p-dropdown>
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td>
                        <p>
                            Destination country
                        </p>
                    </td>
                    <td>
                        <p-dropdown placeholder="SELECT" dataKey="id" [options]="contactRequestService.filteredCountries" optionLabel="name"
                            [showClear]="true" (onChange)="updateSchools($event.value)" formControlName="destination"
                            [filter]="true">
                        </p-dropdown>
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td>
                        <p>
                            Start date
                        </p>
                    </td>
                    <td>
                        <p-calendar [monthNavigator]="true" [yearRange]="travelYearRange" [yearNavigator]="true"
                            formControlName="startDate" dateFormat="dd/mm/yy" [showIcon]="true"
                            (onSelect)="updateQuotationRequestDuration($event); updateAgeAtStartDate($event)">
                        </p-calendar>
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td>
                        <p>
                            End date
                        </p>
                    </td>
                    <td>
                        <p-calendar [monthNavigator]="true" [yearRange]="travelYearRange" [yearNavigator]="true"
                            formControlName="endDate" dateFormat="dd/mm/yy" [showIcon]="true"
                            (onSelect)="updateQuotationRequestDuration($event)"></p-calendar>
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td>
                        <p>
                            Duration
                        </p>
                    </td>
                    <td>
                        <p *ngIf="contactRequestService.contactRequest.duration">
                            {{contactRequestService.contactRequest.duration}} weeks
                        </p>
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td>
                        <p>
                            Course intensity
                        </p>
                    </td>
                    <td>
                        <input pInputText formControlName="courseType">
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td>
                        <p>
                            Course option
                        </p>
                    </td>
                    <td>
                        <input pInputText formControlName="courseOption">
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td colspan="2">
                        <h4>
                            Accommodation information
                        </h4>
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td>
                        <p>
                            Accommodation
                        </p>
                    </td>
                    <td>
                        <p-dropdown placeholder="SELECT" dataKey="id" [options]="accommodationTypes" optionLabel="name"
                            formControlName="accommodationType"></p-dropdown>
                    </td>
                </tr>
                <tr
                    *ngIf="contactRequestForm.get('accommodationType')!.value && contactRequestForm.get('accommodationType')!.value.id == 7">
                    <td>

                    </td>
                    <td>
                        <input pInputText formControlName="otherAccommodationType">
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td>
                        <p>
                            Room
                        </p>
                    </td>
                    <td>
                        <p-dropdown placeholder="SELECT" dataKey="id" [options]="roomTypes" optionLabel="name"
                            formControlName="roomType"></p-dropdown>
                    </td>
                </tr>
                <tr
                    *ngIf="contactRequestForm.get('roomType')!.value && contactRequestForm.get('roomType')!.value.id == 5">
                    <td>

                    </td>
                    <td>
                        <input pInputText formControlName="otherRoomType">
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td>
                        <p>
                            Board
                        </p>
                    </td>
                    <td>
                        <p-dropdown placeholder="SELECT" dataKey="id" [options]="boardTypes" optionLabel="name"
                            formControlName="boardType"></p-dropdown>
                    </td>
                </tr>
                <tr
                    *ngIf="contactRequestForm.get('boardType')!.value && contactRequestForm.get('boardType')!.value.id == 5">
                    <td>

                    </td>
                    <td>
                        <input pInputText formControlName="otherBoardType">
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td colspan="2">
                        <h4>
                            Additional information
                        </h4>
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td>
                        <p>
                            Travel Insurance
                        </p>
                    </td>
                    <td>
                        <p-checkbox [binary]="true"
                            [formControl]="contactRequestForm.controls['needInsurance'] | formControl">
                        </p-checkbox>
                    </td>
                </tr>
                <tr class="contact-list-item">
                    <td>
                        <p>
                            Cancellation Insurance
                        </p>
                    </td>
                    <td>
                        <p-checkbox [binary]="true"
                            [formControl]="contactRequestForm.controls['needGarantieAnnulation'] | formControl"></p-checkbox>
                    </td>
                </tr>
                <tr>
                    <td class="contact-message-box-title">
                        <p>
                            Message
                        </p>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" class="contact-message-box">
                        <div>
                            {{contactRequestService.contactRequest.message}}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div class="actions-container">
        <div class="action-title-container">
            <h4>
                Follow-up
            </h4>
        </div>
        <div class="relance-buttons-container">
            <p-button [disabled]="contactRequestService.contactRequest.isDeleted" (onClick)="setDateToContact(3)"
                label="Three days from today" [style]="{'width':'200px'}"></p-button>
            <p-button [disabled]="contactRequestService.contactRequest.isDeleted" (onClick)="setDateToContact(5)"
                label="Five days from today" [style]="{'width':'200px'}"></p-button>
            <p-button [disabled]="contactRequestService.contactRequest.isDeleted" (onClick)="setDateToContact(7)"
                label="One week from today" [style]="{'width':'200px'}"></p-button>
        </div>
        <div class="action-title-container">
            <h4>
                Custom date
            </h4>
        </div>
        <div class="custom-date">
            <p-calendar [disabled]="contactRequestService.contactRequest.isDeleted" [(ngModel)]="selectedDate"
                dateFormat="dd/mm/yy" [readonlyInput]="true" [showIcon]="true"></p-calendar>
            <p-button [disabled]="!selectedDate || contactRequestService.contactRequest.isDeleted"
                (onClick)="setCustomDateToContact()" label="Set custom date"></p-button>
        </div>
        <p *ngIf="contactRequestService.contactRequest.dateToContact">
            Follow-up programmed for: {{contactRequestService.contactRequest.dateToContact.toDate() | date:
            "dd/MM/yyyy"}}
        </p>
        <div class="interest-level-container">
            <div class="action-title-container">
                <h4>
                    Interest level
                </h4>
            </div>
            <p-selectButton [options]="interestLevels" optionLabel="name" [(ngModel)]="selectedInterestLevel"
                [disabled]="contactRequestService.contactRequest.isDeleted"
                (onChange)="interestLevelChange($event.value)">
            </p-selectButton>
        </div>
        <div class="action-title-container">
            <h4>
                Update
            </h4>
        </div>
        <div [formGroup]="commentForm" class="comment-form">
            <textarea pInputTextarea cols="32" rows="10" formControlName="body"></textarea>
            <div class="comment-post-button-wrap">
                <p-button [disabled]="commentForm.invalid || contactRequestService.contactRequest.isDeleted"
                    (onClick)="postComment()" label="Post" [style]="{'width':'120px'}"></p-button>
            </div>
        </div>
        <div class="comment-list-container">
            <div *ngFor="let comment of comments">
                <div class="comment-body-container">
                    <p class="comment-body">
                        {{comment.body}}
                    </p>
                </div>
                <div class="comment-footer">
                    {{comment.createdBy!.name!}} on {{comment.created! | date:"dd/MM/yyyy HH:mm"}}
                </div>
            </div>
            <div class="mail-history-items-container">
                <p-card *ngFor="let history of emailHistories">
                    <p>
                        Mail Sent - {{history.email.sentDateTime?.toDate() | date:'dd/MM/yyyy - HH:mm'}}
                    </p>
                    <p-button label="VIEW E-MAIL" (onClick)="activateEmailHistoryDetail(history)"
                        class="view-email-button"></p-button>
                    <div *ngIf="history.email.isOpened" class="tag-item">
                        Seen on: {{history.email.openedAt?.toDate() | date:'dd/MM/yyyy - HH:mm'}}
                    </div>
                </p-card>
            </div>
        </div>
    </div>
    <p-dialog [modal]="true" [(visible)]="displayMailHistoryDetail"
        header="Details of email sent #{{selectedEmailHistory.email.id!}}" *ngIf="selectedEmailHistory">
        <div class="email-history-container">
            <div class="email-line-item">
                <span class="email-item">Mail sent by </span>
                <span><strong>{{selectedEmailHistory.email.sentBy.name}}</strong></span>
                <span class="email-item"> on </span>
                <span>
                    <strong>
                        {{selectedEmailHistory.email.sentDateTime?.toDate() | date:'dd/MM/yyyy - HH:mm'}}
                    </strong>
                </span>
            </div>
            <div class="email-line-item">
                <span class="email-item">
                    Subject:
                </span>
                <span>
                    <strong>
                        {{selectedEmailHistory.email.subject}}
                    </strong>
                </span>
            </div>
            <div class="email-message-section-container">
                <p class="email-item">
                    Message:
                </p>
                <div [innerHTML]="selectedEmailHistory.email.body" class="sent-email-message-container"></div>
                <div
                    *ngIf="selectedEmailHistory.attachmentFileNames && selectedEmailHistory.attachmentFileNames.length > 0">
                    <p class="email-item">
                        Attachment:
                    </p>
                    <p *ngFor="let fileName of selectedEmailHistory.attachmentFileNames">
                        {{fileName}}
                    </p>
                </div>
            </div>
        </div>
    </p-dialog>

    <p-dialog header="Send email to: {{contactRequestService.contactRequest.email}}" [(visible)]="displayMailingDialog"
        [modal]="true" [style]="{width: '50vw', height: '84vh'}">
        <div *ngIf="emailSending" class="spinner-container">
            <app-loading-spinner></app-loading-spinner>
        </div>

        <div *ngIf="!emailSending">
            <div [formGroup]="emailForm" *ngIf="emailForm" class="email-form-container">
                <h3 class="global-title">Customer message</h3>
                <p>{{contactRequestService.contactRequest.message}}</p>
                <br>
                <p-dropdown placeholder="load a template" [options]="emailTemplates" optionLabel="name"
                    formControlName="emailTemplate" (onChange)="insertLeadEmailTemplate($event.value)"></p-dropdown>
                <div>
                    <div>
                        <p>Subject: </p>
                    </div>
                    <div>
                        <input formControlName="subject" pInputText class="subject-input">
                    </div>
                </div>
                <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
                <span>
                    Signature:
                </span>
                <p-dropdown placeholder="Signature" formControlName="signature"
                    [options]="contactRequestService.emailSignatures" optionLabel="language.name"></p-dropdown>
                    <div>
                        <span>
                            Paste Pixel
                        </span>
                        <p-checkbox [binary]="true" formControlName="withPastePixel"></p-checkbox>
                    </div>
            </div>
            <div *ngIf="attachmentLoading">
                <p>Loading file...</p>
            </div>
            <div *ngFor="let item of attachmentQuotations">
                <a [href]="getObjectURL(item.file)" [download]="item.file.name">{{item.file.name}} ({{item.file.size /
                    1000}} KB)</a>
                <p-button (onClick)="removeAttachmentFile(item.file)" label="X"></p-button>
            </div>
            <div>
                <p-button (onClick)="loadQuotation()" label="Load quotation"></p-button>
            </div>

            <div class="send-button-container">
                <div class="send-button-wrap">
                    <p-button label="Send" (onClick)="sendEmailToClient()"
                        [disabled]="attachmentLoading || emailSending">
                    </p-button>
                </div>
                <div class="cancel-button-wrap">
                    <p-button label="Cancel" (onClick)="closeEmailModal()" styleClass="p-button-warning"
                        [disabled]="attachmentLoading || emailSending"></p-button>
                </div>
            </div>
        </div>
    </p-dialog>
    <p-dialog header="attach a quotation" [(visible)]="displayQuotationSelection" [modal]="true"
        [style]="{width: '25vw'}">
        <div class="attachment-container">
            <p-dropdown placeholder="select quotation" [options]="quotations" optionLabel="description"
                (onChange)="loadSelectedQuotation()" [(ngModel)]="selectedQuotation"></p-dropdown>
        </div>
    </p-dialog>
</div>